import { render, staticRenderFns } from "./infoBoardDiceQuestion.vue?vue&type=template&id=46874de4&scoped=true&"
import script from "./infoBoardDiceQuestion.vue?vue&type=script&lang=js&"
export * from "./infoBoardDiceQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46874de4",
  null
  
)

export default component.exports